module.exports = __webpack_public_path__ + "media/Components/Logos/WeLoveLaser_Logo-aeeb7a9cfdd035f7437bd900e0a924c0.svg";